import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ReservationForm from './components/ReservationForm';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
import AdminGestionPage from './pages/AdminGestionPage';
import AdminDisponibilitesPage from './pages/AdminDisponibilitesPage';
import AdminVitrinePage from './pages/AdminVitrinePage';
import LoginPage from './pages/LoginPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<><Header /><HomePage /></>} />
        <Route path="/reservation" element={<><Header /><ReservationForm clientId={1} /></>} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/gestion" element={<AdminGestionPage />} />
        <Route path="/admin/disponibilites" element={<AdminDisponibilitesPage />} />
        <Route path="/admin/vitrine" element={<AdminVitrinePage />} />
      </Routes>
    </Router>
  );
}

export default App;
